import React, { useState } from "react";

import BaseWrapper from "../../components/ui/BaseWrapper";
import useAuth from "../../hooks/useAuth";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import CompleteProfileModal from "../WorkJobDetails/CompleteProfileModal";
import BaseButton from "../../components/ui/BaseButton";
import { ModuleType, WorkOrderStatusType } from "../../utils/enum";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/toast/toastSlice";
const CustomerWorkOrderListingHeader = ({
  selectedWorkOrders,
  status,
  setIsGenerateInvoiceModalOpen,
  selectedClient,
  currency,
}) => {
  const dispatch = useDispatch();
  const hasPoPending = selectedWorkOrders?.some((wo) => wo?.subStatus === "PO_PENDING");

  const { authRole, getPermissionForModule } = useAuth();

  const { hasWriteAccess: hasCustomerWriteAccess } = getPermissionForModule(
    ModuleType.CUSTOMER_INVOICE,
  );
  const { userData } = useCurrentUser();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  return (
    <div className="border-b border-zinc-300 bg-white ">
      <BaseWrapper>
        <div className="grid grid-cols-7 gap-y-3 py-[7px] items-center">
          <div className="md:col-span-6 col-span-7">
            <h3 className="font-light md:text-left text-center">Customer Work Orders</h3>
          </div>
          <div className="md:col-span-1 col-span-7 flex justify-end">
            {selectedWorkOrders?.length > 0 &&
              status?.includes(WorkOrderStatusType.APPROVED) &&
              selectedClient?.clientId &&
              currency &&
              hasCustomerWriteAccess && (
                <BaseButton
                  color="primary"
                  className="py-[4px] px-[24px] "
                  onClick={() => {
                    if (hasPoPending) {
                      dispatch(
                        showToast({
                          message: "Cannot generate invoice. Some work orders are PO Pending.",
                          type: "error",
                        }),
                      );

                      return;
                    }
                    if (!hasPoPending) {
                      setIsGenerateInvoiceModalOpen(true);
                    }
                  }}
                >
                  Generate Invoice
                </BaseButton>
              )}
          </div>
        </div>
      </BaseWrapper>
      {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </div>
  );
};

export default CustomerWorkOrderListingHeader;
